import React, { Component } from 'react';
import { ColorButton, TransparentButton, DeleteModal } from '../../../../../neoverv';
import { Badge } from 'react-bootstrap';
import Autoload from '../../../../../neoverv/Autoload';
import moment from 'moment';
import { connect } from 'react-redux';
import { Group, Skeleton, Stack } from '@mantine/core';
import { Row, Col, Form } from 'react-bootstrap';
import StarterBadgeIcon from '../../../../../assets/images/module/general/StarterBadgeIcon.svg';
import PremiumBadgeIcon from '../../../../../assets/images/module/general/PremiumBadgeIcon.svg';
import ProfessionalBadgeIcon from '../../../../../assets/images/module/general/ProfessionalBadgeIcon.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import NewSubscription from './NewSubscription';
import { Route } from 'react-router-dom';
import PaymentConfirmationModal from '../../../../../neoverv/components/Module/General/CustomModal/PaymentConfirmationModal';
import { formatNumber } from '../../../../../helpers/stringsManipulations';
import { hideNotification, showNotification } from '@mantine/notifications';
import {
  setSubscriptionData,
  setCurrentSubscriptionData,
  setCurrentSubscriptionDataWithPaymentError,
  setSelectedSubscriptionForPaymentConfirmation,
  setAccountData,
  setCompanyLogo,
  setNextSubscriptionData,
  setTestSubscriptionComplete,
  setIsTesting,
  setIsLogoHidden
} from '../../../../../redux/action/General/generalActions';
import { getCookie, setCookie } from '../../../../../neoverv/helpers/Utils';
import PaymentTemplateSuccessModal from '../../../../../neoverv/components/Module/General/CustomModal/PaymentTemplateSuccessModal';
import PaymentTemplateModal from '../../../../../neoverv/components/Module/General/CustomModal/PaymentTemplateModal';
import dayjs from 'dayjs';
import { id } from 'chartjs-plugin-style';
import RestrictedMenuMessageModal from '../../../../../neoverv/components/Module/General/CustomModal/RestrictedMenuMessageModal';
import SubscriptionBadgeIcon from '../../../../../neoverv/components/SVGs/SubscriptionBadgeIcon';
import { BILLING_PERIOD, getBillingPeriod, getMonthlyEquivalentPrice, isAnnualSubscription, splitPriceForDisplay, getBillingPeriodLabel, getBillingPeriodSuffix, getAnnualSavingsPercent, formatSavingsPercent } from '../../../../../helpers/subscriptionBilling';
import { getSubscriptionTier, isStarterTier } from '../../../../../helpers/subscriptionFeatureAccess';
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, loader } = Autoload.MainHelper;
export class YourSubscription extends Component {
  state = {
    subscriptionPlan: null,
    subscriptionlastDate: '',
    openModal: false,
    skeletonLoading: false,
    showNewSubscription: false,
    subscribtionSelected: '',
    subscribtionSelectedName: null,
    paymentConfirmationModal: false,
    paymentMethodStatus: false,
    paymentMandate: null,
    subscriptionTypes: [],
    currentSubsId: null,
    type: null,
    openPaymentStatusModal: false,
    openPaymentRedirectModal: false,
    showLoader: false,
    nextSubscription: null,
    cancelSubscriptionModal: false,
    openRestrictedMenuMessage: false,
    isReactivating: false,
    isCanceling: false
    // subscriptionData: [{ subscriptionAmount: '', subscriptionRenewDate: '', subscriptionlastDate: '' }],
  };

  onInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  componentDidMount() {
    // var loader = document.getElementById('hello-housing-loader');
    // loader.style.display = 'block';
    
    const {subscriptionData, subscriptionTypes, subscribtionSelected, paymentMandate} = this.state;
    const selectedSubscription = this.props.history.location.state && this.props.history.location.state.selectedSubscription ? this.props.history.location.state.selectedSubscription : null;
    let showNewSubscription = this.props.location.state && this.props.location.state.newSubscription ? this.props.location.state.newSubscription : false;
    
    this.getAccountById();

    this.setState({skeletonLoading: true, showNewSubscription, subscribtionSelected: selectedSubscription ? selectedSubscription : subscribtionSelected, paymentConfirmationModal: selectedSubscription && this.props.accountData.accountPaymentStatus === 'AUTHORIZED' && true, openPaymentStatusModal: selectedSubscription && this.props.accountData.accountPaymentStatus !== 'AUTHORIZED' && true});
    console.log('this.props.newSubscription: ', showNewSubscription);

    this.getsubscriptionsTypes();

    let paymentAuthorizeInProgress = getCookie('PaymentAuthorizeInProgress');
    let paymentReAuthorizeInProgress = getCookie('paymentReAuthorizeInProgress');
    
    if (paymentAuthorizeInProgress === '1') {
      loader(true);
      let route = getCookie('PaymentAuthorizeRoute');
      let subscribtionSelected = getCookie('SubscriptionSelected');
      if(route === '/profile/yourSubscription'){
        //setCookie('PaymentAuthorizeInProgress', '0');
        this.setState({type: 'authorize', subscribtionSelected: this.props.selectedSubscriptionForPaymentConfirmation}, ()=> {
          setCookie('SubscriptionSelected', null);
        });
        setTimeout(() => {
          //this.getPaymentStatus();
          this.setState({openPaymentStatusModal: true}, ()=> setCookie('PaymentAuthorizeRoute', null));
        }, 3000);
      }else{
        loader(false);
      }
    }else if(paymentReAuthorizeInProgress === '1'){
      loader(true);
      let route = getCookie('PaymentAuthorizeRoute');
      let subscribtionSelected = getCookie('SubscriptionSelected');
      if(route === '/profile/yourSubscription'){
        //setCookie('PaymentAuthorizeInProgress', '0');
        this.setState({type: 'authorize', subscribtionSelected: this.props.selectedSubscriptionForPaymentConfirmation}, ()=> {
          setCookie('SubscriptionSelected', null);
        });
        setTimeout(() => {
          //this.getPaymentStatus();
          this.setState({openPaymentStatusModal: true}, ()=> setCookie('PaymentAuthorizeRoute', null));
        }, 3000);
      }else{
        loader(false);
      }
    }

    // let url = new URL(window.location.href);
    // this.setState({
    //   paymentConfirmationModal: JSON.parse(url.searchParams.get("paymentStatus")) !== null && JSON.parse(url.searchParams.get("paymentStatus")) === true ? true : false, 
    //   paymentMethodStatus: JSON.parse(url.searchParams.get("paymentStatus"))
    // }) 
  }

  getAccountById=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + this.props.profile.accountId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_account_by_id',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_account_by_id(response){
    if(response.status && response.statuscode === 200){
      this.props.setAccountData(response.result);
      this.props.setIsLogoHidden(response?.result?.logoPreference === 'None');
      this.props.setCompanyLogo(response?.result?.logoPreference);//Autoload.MainHelper.checkProperty(response.result, 'useOwnLogo'));
    }
  }

  getPaymentStatus = () => {
    loader(true);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + this.props.profile.accountId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handlePaymentStatusResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handlePaymentStatusResponse(response) {
    console.log('okk')
    this.paymentLoop = this.paymentLoop + 1;
    if (response.status) {
      const status = Autoload.MainHelper.checkProperty(response.result, 'accountPaymentStatus');

      switch (status) {
        case 'INITIATED':
          if (this.paymentLoop < 4) {
            setTimeout(() => {
              this.getPaymentStatus();
            }, 5000);
            break;
          } else {
            this.setState({ paymentStatus: 'PAYMENT_ERROR' });
            //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_paymentUpdated_failure);
            loader(false);
            //this.setState({ showPaymentMessage: true });
            break;
          }
        case 'AUTHORIZED':
          this.setState({ paymentStatus: status });
          //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_paymentUpdated_success);
          loader(false);
          //this.setState({ showPaymentMessage: true });
          break;
        case 'PAYMENT_ERROR':
          this.setState({ paymentStatus: 'PAYMENT_ERROR' });
          //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_paymentUpdated_failure);
          loader(false);
          //this.setState({ showPaymentMessage: true });
          break;
        default:
          this.setState({ paymentStatus: 'SERVER_ERROR' });
          //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_paymentUpdated_failure);
          loader(false);
          //this.setState({ showPaymentMessage: true });
          break;
      }
    } else {
      this.setState({ paymentStatus: 'SERVER_ERROR' });
      //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_paymentUpdated_failure);
      //this.setState({ showPaymentMessage: true });
      loader(false);
    }

    this.setState({openPaymentStatusModal: true});
  };

  getPaymentDetails = () => {
    console.log('this.props.profile', this.props.profile.accountId, this.props.profile);
    const userAccountID = this.props.profile.accountId;
    // console.log(userAccountID, 'userAccountID from redux - payment details page');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + userAccountID + '/paymentMandate',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_account_payment_details',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handle_account_payment_details(response) {
    console.log('handle_account_payment_details response', response);
    if (response.status == true && response.statuscode == 200) {
      this.setState({
        paymentMandate: response.result
      });
    }
    this.getsubscriptionsAssignments();
    document.getElementById('get-account-by-id')?.click();
  }

  getsubscriptionsTypes = async () => {
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'subscriptions',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_subscriptions_types',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_subscriptions_types(response){
    console.log('handle_subscriptions_types: ', response);
    if(response.status){
      this.setState({subscriptionTypes: response.result});
    }
    this.getPaymentDetails();
  }

  getsubscriptionsAssignments = async (subscriptionChanged=false) => {
    document.getElementById('get-subscriptions-assignments')?.click();
    // const userAccountID = this.props.profile.accountId;
    // Autoload.HttpRequestAxios.HttpRequest(
    //   Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments?accountId=' + userAccountID,
    //   'GET',
    //   null,
    //   null,
    //   false,
    //   true,
    //   false,
    //   this,
    //   'handle_subscriptions_Assignments_details',
    //   {subscriptionChanged: subscriptionChanged},
    //   false,
    //   '',
    //   {
    //     'Content-Type': 'application/json',
    //     Authorization: Autoload.Utils.getAuthToken(),
    //   }
    // );
  };

  handle_subscriptions_Assignments_details(response) {
    let {subscriptionTypes, paymentMandate} = this.state;
    console.log('profile ssubscription api', response);
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {

      let subscriptionData= response.result.filter((subscription)=> subscription.subscriptionType.type === 'MAIN').map((data, index) => {
        return {
          subscriptionRenewDate: moment(data.nextRenewalDate).format('DD.MM.YYYY'),
          subscriptionAmount: checkProperty(checkProperty(data, 'subscriptionType'), 'price'),
          subscriptionBilling: checkProperty(checkProperty(data, 'subscriptionType'), 'billing'),
          subscriptionKey: checkProperty(checkProperty(data, 'subscriptionType'), 'subscriptionKey'),
          subscriptionName: checkProperty(checkProperty(data, 'subscriptionType'), 'name'),
          category: checkProperty(checkProperty(data, 'subscriptionType'), 'category'),
          subscriptionTypeId: checkProperty(checkProperty(data, 'subscriptionType'), 'subscriptionTypeId'),
          subscriptionStatus: checkProperty(data, 'subscriptionStatus'),
          testPeriodEnd: checkProperty(data, 'testPeriodEndDate'),
          subscriptionEndDate: moment(data.testPeriodEndDate).format('DD.MM.YYYY'),
          subscriptionAssignment: checkProperty(data, 'id'),
          nextPaymentDue: moment(data.nextPaymentDate).format('DD.MM.YYYY'),
          possibleCancellationDate: moment(data.nextPaymentDate).subtract(1, 'days').format('DD.MM.YYYY'),
          cancellatinoDate: moment(data.cancelationDate).format('DD.MM.YYYY'),
          limitProperties: checkProperty(checkProperty(data, 'subscriptionType'), 'limitProperties'),
          limitRentalUnits: checkProperty(checkProperty(data, 'subscriptionType'), 'limitRentalUnits'),
          type:checkProperty(checkProperty(data, 'subscriptionType'), 'type'),
          cancellationDateWithoutFormat: data.cancelationDate,
          startDate: moment(data.startDate).format('DD.MM.YYYY'),
        };
      });
      //response.result.splice(0, 1); // Remove first array element so only the second one interests us (I know it's not beautyiful but it works)
      let currentSubscription = this.props.accountData?.accountPaymentStatus === 'PAYMENT_ERROR' ?
      null
      :
      subscriptionData.sort((a,b)=> a.subscriptionStatus.toString().localeCompare(b.subscriptionStatus).toString()).find((subs)=> subs.subscriptionStatus === 'ACTIVE' ? 
      subs.subscriptionKey === 'PROFESSIONAL_TESTING_12_2024' ? 
      dayjs().isBefore(dayjs(subs.testPeriodEnd)) 
      : 
      moment(subs.startDate, 'DD.MM.YYYY').format('YYYY-MM-DDT00:00:00') <= moment().format('YYYY-MM-DDT00:00:00') 
      : 
      subs.subscriptionStatus === 'CANCELLED' ? 
        (subs.subscriptionKey === 'STARTER_03_2023' && dayjs(subs.cancellatinoDate, 'DD.MM.YYYY').isAfter(dayjs())) ?
        subs  
        :
        moment(subs.nextPaymentDue, 'DD.MM.YYYY').format('YYYY-MM-DDT00:00:00') > moment().format('YYYY-MM-DDT00:00:00') 
      : 
      (subs.subscriptionStatus === 'SWITCHED' && subs.subscriptionKey === 'PROFESSIONAL_TESTING_12_2024') ? 
      dayjs().isBefore(dayjs(subs.testPeriodEnd)) 
      : 
      null);
      console.log('subscriptionData_2232: ', currentSubscription);
      currentSubscription = currentSubscription !== undefined ? currentSubscription : null;//subscriptionData.find((subs)=> subs.subscriptionName === 'Starter');
      // if(subscriptionTypes.find((subscriptionType)=> subscriptionType?.subscriptionTypeId === currentSubscription?.subscriptionTypeId) === undefined){
      //   subscriptionTypes= [...subscriptionTypes, response.result.find((subscriptionAssignment)=> subscriptionAssignment.subscriptionType.subscriptionTypeId === currentSubscription?.subscriptionTypeId)?.subscriptionType];
      //   this.setState({subscriptionTypes});
      // }
      response.other.subscriptionChanged && this.props.setSubscriptionData(subscriptionData);
      
      response.other.subscriptionChanged && this.props.setCurrentSubscriptionData(currentSubscription !== undefined ? (((currentSubscription?.subscriptionStatus === 'ACTIVE' || currentSubscription?.subscriptionStatus === 'CANCELLED') && (this.props.accountData.accountPaymentStatus === null || this.props.accountData.accountPaymentStatus === 'PAYMENT_ERROR')) ? null//subscriptionData.find((subs)=> subs.subscriptionName === 'Starter') 
      : currentSubscription) : null);//subscriptionData.find((subs)=> subs.subscriptionName === 'Starter'));
      
      let isTesting= response.result.filter((subscription)=> subscription.subscriptionType.type === 'MAIN').find((subscriptionAssignment)=> subscriptionAssignment?.subscriptionType?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7' && (dayjs().isBefore(dayjs(subscriptionAssignment?.testPeriodEndDate)) || dayjs().isSame(dayjs(subscriptionAssignment?.testPeriodEndDate))));
      let hasTested= response.result.filter((subscription)=> subscription.subscriptionType.type === 'MAIN').find((subscriptionAssignment)=> subscriptionAssignment?.subscriptionType?.subscriptionKey.includes('2023')	|| subscriptionAssignment?.subscriptionType?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7' && dayjs().isAfter(dayjs(subscriptionAssignment?.testPeriodEndDate)));
      this.props.setTestSubscriptionComplete(hasTested ? true : false);
      this.props.setIsTesting(isTesting ? true : false);

      let nextSubscription = subscriptionData.find((subs)=> subs.subscriptionStatus === 'ACTIVE' && moment(subs.startDate, 'DD.MM.YYYY').format('YYYY-MM-DDT00:00:00') > moment().format('YYYY-MM-DDT00:00:00'));
      response.other.subscriptionChanged && this.props.setNextSubscriptionData(nextSubscription !== undefined ? nextSubscription : null);

      this.setState({
        subscriptionData,
        nextSubscription
        //currentSubscription?.subscriptionStatus === 'CANCELLED' ? subscriptionData.find((subs)=> subs.subscriptionName !== 'Starter' && subs.subscriptionStatus === 'ACTIVE' && (dayjs(subs.startDate, 'DD.MM.YYYY').isSame(dayjs(currentSubscription?.cancellatinoDate, 'DD.MM.YYYY')) || dayjs(subs.startDate, 'DD.MM.YYYY').isAfter(dayjs(currentSubscription?.cancellatinoDate, 'DD.MM.YYYY')))) : null
      });
      //response.other.subscriptionChanged && this.props.setCurrentSubscriptionData(currentSubscription !== undefined ? currentSubscription : subscriptionData.find((subs)=> subs.subscriptionName === 'Starter'));

      //console.log('renewDate: ', this.props.currentSubscription?.nextPaymentDue);
      this.setState({
        renewDate: this.props.currentSubscription?.nextPaymentDue,
        currentSubsId: this.props.currentSubscription?.subscriptionAssignment,
        subscriptionName: this.props.currentSubscription?.subscriptionName
      });

      if(currentSubscription !== undefined && (currentSubscription?.subscriptionStatus === 'ACTIVE' || currentSubscription?.subscriptionStatus === 'CANCELLED') && this.props.accountData?.accountPaymentStatus === 'PAYMENT_ERROR'){
        if(currentSubscription?.subscriptionStatus === 'ACTIVE'){
          showNotification({
            message: <span>Bei der Zahlungsabwicklung Ihres Abonnements ist ein Fehler aufgetreten. Ihr Zugriff auf hellohousing ist derzeit eingeschränkt. Bitte <span onClick={()=> this.props.history.push('/profile/paymentDetails/')} style={{color: '#5555FF', cursor: 'pointer'}}>reaktivieren Sie die Zahlungsmethode</span>, um den Zugriff wieder herzustellen.</span>,
            disallowClose: true,
            icon: <img src={RedCross} alt='red-cross'/>,
            autoClose: false,
            id: 'paymentErrorMessage',
          })
        }else{
          hideNotification('paymentErrorMessage');
        }
        this.props.setCurrentSubscriptionDataWithPaymentError(currentSubscription !== undefined ? currentSubscription : null);//subscriptionData.find((subs)=> subs.subscriptionName === 'Starter'));
      }else{
        hideNotification('paymentErrorMessage');
        this.props.setCurrentSubscriptionDataWithPaymentError(null);
      }

      if(response.other.subscriptionChanged){
        window.Intercom("update", {
          'Current Plan': currentSubscription !== undefined ? currentSubscription?.subscriptionStatus === 'CANCELLED' ? `${currentSubscription?.subscriptionKey}_CANCELLED` : currentSubscription?.subscriptionKey : 'No ACTIVE or CANCELLED Subscription Assigned',
          'Next Plan': (nextSubscription !== undefined && nextSubscription !== null) ? nextSubscription?.subscriptionKey : null,
          'Next Plan Start Date': (nextSubscription !== undefined && nextSubscription !== null) ? nextSubscription?.startDate : null,
          "Payment method": paymentMandate?.paymentMethod ? (paymentMandate?.isManuallyCreated && paymentMandate?.paymentMethod === 'directdebit') ? 'directdebit-hh' : paymentMandate?.paymentMethod : 'none',
          "Payment mandate id": paymentMandate?.paymentMandateid ? paymentMandate?.paymentMandateid : 'none'
        });
      }else{
        window.Intercom("update", {
          "Payment method": paymentMandate?.paymentMethod ? (paymentMandate?.isManuallyCreated && paymentMandate?.paymentMethod === 'directdebit') ? 'directdebit-hh' : paymentMandate?.paymentMethod : 'none',
          "Payment mandate id": paymentMandate?.paymentMandateid ? paymentMandate?.paymentMandateid : 'none'
        });
      }

      // console.log(this.state.subscriptionData,this.state.subscriptionRenewDate.,'====subscriptionData====');
    }

    this.ShowLoader();
  }
  toggleModal = (subscriptionStatus, testPeriodEnd, id, subscriptionRenewDate) => {
    // if periodEndDate before todaydate or today and endDate is same true means still active - case 1
    // if  periodEndDate before todaydate then false means over - case 2
    // console.log(date, testDate, testPeriod, 'abc');
    var date = moment(new Date()).format('YYYY-MM-DD');
    var testDate = moment(testPeriodEnd).format('YYYY-MM-DD');
    var testPeriod = moment(date).isSameOrBefore(testDate);

    this.setState({
      subsStatus: subscriptionStatus,
      subsEndPeriod: testPeriodEnd,
      subsId: id,
      testPeriodCheck: testPeriod,
      renewDate: subscriptionRenewDate,
      openModal: !this.state.openModal,
    });
  };
  // Cancels the plan shown on the page. While a payment has failed, Main.js keeps that plan in
  // currentSubscriptionWithPaymentError and sets currentSubscription to null.
  reactivateCancelSub() {
    const { currentSubscription, currentSubscriptionWithPaymentError } = this.props;
    const subscription = currentSubscriptionWithPaymentError || currentSubscription;
    this.cancelSubscriptionAPi(subscription?.subscriptionAssignment, subscription?.subscriptionKey);
  }
  cancelSubscriptionAPi(id, subscriptionKey=null) {
    if (this.state.isCanceling) return;
    this.setState({ isCanceling: true });
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments/' + id + '/cancel',
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_cancel_subscription',
      {subscriptionKey},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handle_cancel_subscription(response) {
    this.setState({ openModal: false, isCanceling: false });
    if(response.status){
      var metadata = {
        subscriptionKey: response?.other?.subscriptionKey
      };
      window.Intercom('trackEvent', 'plan-cancelled', metadata);
      showNotification({
        message: 'Die Kündigung Ihres Abonnements wurde durchgeführt.',
        icon: <img src={GreenTick} alt='green-tick'/>,
      });
      this.getsubscriptionsAssignments(true);
    }
    else{
      showNotification({
        message: 'Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
      this.getsubscriptionsAssignments();
    }
    
  }
  // Undoes the cancellation of the current plan. This also undoes a scheduled downgrade: the
  // backend reactivates the current plan and drops the plan that was to follow it (it turns
  // SWITCHED). Cancelling the follow-up plan instead would leave the current plan with its old
  // cancellation date.
  reactivateSubscriptinApi(){
    if (this.state.isReactivating) return;
    this.setState({ isReactivating: true });

    const { currentSubscription, currentSubscriptionWithPaymentError } = this.props;
    let subscription = currentSubscriptionWithPaymentError || currentSubscription;
    
    if(subscription?.subscriptionStatus === 'CANCELLED' && dayjs(subscription?.cancellatinoDate, 'DD.MM.YYYY').isAfter(dayjs()) && subscription?.subscriptionAssignment){
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments/' + subscription?.subscriptionAssignment + '/reactivate',
        'PUT',
        null,
        null,
        false,
        true,
        false,
        this,
        'handle_reactivate_cancel_subscription',
        {subscription},
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }else if(subscription?.subscriptionTypeId){
      this.createSubscriptionAssignment(subscription?.subscriptionTypeId);
    } else {
      this.setState({ isReactivating: false }); 
    }
  }
  handle_reactivate_cancel_subscription = (response) => {
    this.setState({ isReactivating: false });
    if (response.statuscode === 200 && response.status) {
      var metadata = {
        subscriptionKey: this.props.currentSubscription?.subscriptionKey
      };
      window.Intercom('trackEvent', 'plan-reactivated', metadata);
      const subscription = response?.other?.subscription;
      showNotification({
        message: `Die Kündigung wurde erfolgreich rückgängig gemacht.${subscription ? ` Sie nutzen weiterhin das ${this.getPlanNameText(subscription)}.` : ''}`,
        icon: <img src={GreenTick} alt='green-tick'/>,
      });
      this.getsubscriptionsAssignments(true);
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
      this.getsubscriptionsAssignments();
    }

    
  };

  createSubscriptionAssignment=(subscriptionTypeId= null, followUpSubscribtion= null)=>{
    this.setState({showLoader: true});
    const userAccountID = this.props.profile.accountId;
    const payload= {
      accountId: userAccountID,
      subscriptionType: {
        SubscriptionTypeId: subscriptionTypeId ? subscriptionTypeId : this.state.subscribtionSelected//'346d7115-782a-43d4-a3c2-2a071a384088'
      }
    }

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handle_subscriptions_Assignments_create',
      {followUpSubscribtion, subscriptionTypeId},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_subscriptions_Assignments_create(response){
    console.log('handle_subscriptions_Assignments_create: ', response);
    if(response.status && response.statuscode === 200){
      showNotification({
        message: response.other.subscriptionTypeId === '97F226D5-A137-48E6-AA9A-605D4488DEC7' ? 'Der Testzeitraum wurde erfolgreich aktiviert.' : 'Vielen Dank! Das Abonnement wurde erfolgreich aktiviert.',
        icon: <img src={GreenTick} alt='green-tick'/>,
        id: 'createSubscriptionAssignmentSuccess'
      });
      let subscription = this.state.subscriptionTypes.find((subs)=> subs?.subscriptionTypeId === this.state.subscribtionSelected);
      this.props.history.push(`${window.location.pathname}?awinTracking=${subscription !== undefined ? subscription.name.toString().toLowerCase() : ''}`);
      this.getsubscriptionsAssignments(true);
      var metadata = {
        subscriptionKey: subscription?.subscriptionKey
      };
      window.Intercom('trackEvent', 'plan-changed', metadata);
      if(response.other.subscriptionTypeId === '97F226D5-A137-48E6-AA9A-605D4488DEC7'){
        window.Intercom('update', {
          "Test Plan End Date": dayjs().add(30, 'days').format()
        });
      }
      this.props.setSelectedSubscriptionForPaymentConfirmation(null);
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
    }
    
    this.setState({showLoader: false, isReactivating: false}, ()=> this.getAccountById());
  }

  ShowLoader = () => {
    const {subscriptionTypes, subscribtionSelected, paymentMandate} = this.state;
    const {nextSubscription, subscriptionData} = this.props;
    //console.log('show loader abc');
    // var loader = document.getElementById('hello-housing-loader');
    // loader.style.display = 'none';
    // var emptyDiv = document.getElementById('empty-user-account-subs-details');
    // emptyDiv.style.display = 'none';
    // var dataDiv = document.getElementById('response-user-account-subs-details');
    // dataDiv.style.display = 'block';

    this.setState({skeletonLoading: false}, ()=> {
      if(this.props.location.state && this.props.location.state.newSubscription ? this.props.location.state.newSubscription : false){
        this.props.history.push('subscriptionsView', {subscriptionData, subscriptionTypes, subscribtionSelected, paymentMandate, nextSubscription})
      }
    });
  };

  authorizePayment=()=>{
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.account_api_baseurl + userAccountID + '/authorizePayment',
        'PUT',
        {
            accountId: userAccountID,
            paymentMethod: null
        },
        null,
        false,
        true,
        false,
        this,
        'handle_account_authorize_payment',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
}
handle_account_authorize_payment(response){
    console.log('handle_account_authorize_payment: ', response);
    if(response.status){
        setCookie('PaymentAuthorizeInProgress', '1');
        setCookie('SubscriptionSelected', this.state.subscribtionSelected);
        this.props.setSelectedSubscriptionForPaymentConfirmation(this.state.subscribtionSelected);
        setCookie('PaymentAuthorizeRoute', '/profile/yourSubscription');
        window.open(response.result, '_self');
    }
}

  // "Aktuelles Abonnement" card. Annual plans show the monthly-equivalent price like the plans page,
  // and paid plans name their billing period underneath. The badge sits in the price row so it
  // lines up with the price, not with the price and the billing line together.
  renderCurrentPlanCard = (subscription) => {
    const price = splitPriceForDisplay(getMonthlyEquivalentPrice(subscription));
    const isPaidPlan = subscription?.subscriptionAmount > 0;
    return (
      <div className='current-subscription-card' style={isPaidPlan ? {height: 'auto', minHeight: '85px'} : undefined}>
        <div style={{width: '100%'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <span className='current-subscription-card-value'>{price.euros}<span style={{fontSize: '13px'}}>{isPaidPlan && price.cents}</span>€</span>
              <span className='current-subscription-card-monat'> / {subscription?.subscriptionBilling === 'daily' ? 'täglich' : 'Monat'}</span>
            </div>
            <SubscriptionBadgeIcon name={subscription?.subscriptionName} category={getSubscriptionTier(subscription)} />
          </div>
          {isPaidPlan &&
          <span className='current-subscription-card-monat' style={{marginLeft: 0}}>{getBillingPeriodLabel(subscription)}</span>}
        </div>
      </div>
    );
  };

  // The texts on this page name a plan as "Premium-Abonnement (jährliche Abrechnung)", always with
  // its billing period. A free plan has none.
  hasBillingPeriod = (subscription) => subscription?.subscriptionAmount > 0;

  // `genitive` gives "Premium-Abonnements", as in "die Kündigung Ihres hellohousing
  // Premium-Abonnements (jährliche Abrechnung)".
  renderPlanName = (subscription, genitive = false) => (
    <>
      <span style={{fontWeight: 'bold'}}>{subscription?.subscriptionName}-Abonnement{genitive ? 's' : ''}</span>
      {this.hasBillingPeriod(subscription) && ` ${getBillingPeriodSuffix(subscription)}`}
    </>
  );

  // The same as plain text, for notifications.
  getPlanNameText = (subscription) =>
    `hellohousing ${subscription?.subscriptionName}-Abonnement${this.hasBillingPeriod(subscription) ? ` ${getBillingPeriodSuffix(subscription)}` : ''}`;

  // A plan under "Ihre Optionen" opens the confirmation modal right here, with the same checks as a
  // plan picked on the plans page: an account that never tested hellohousing gets the trial dialog,
  // and an account without a payment method is asked for one first.
  selectOption = (subscriptionType) => {
    const { hasTested, currentSubscription, accountData } = this.props;
    const { paymentMandate } = this.state;
    if (subscriptionType.status !== 'Available') {
      return;
    }
    if (!hasTested && currentSubscription?.subscriptionTypeId !== '97f226d5-a137-48e6-aa9a-605d4488dec7') {
      this.setState({openRestrictedMenuMessage: true});
    } else if (paymentMandate) {
      const isAuthorized = accountData?.accountPaymentStatus === 'AUTHORIZED';
      this.setState({subscribtionSelected: subscriptionType.subscriptionTypeId, paymentConfirmationModal: isAuthorized, openPaymentStatusModal: !isAuthorized});
    } else {
      this.setState({subscribtionSelected: subscriptionType.subscriptionTypeId, subscribtionSelectedName: subscriptionType.name, openPaymentRedirectModal: true});
    }
  };

  // The texts under the current plan's card. The view for a failed payment shows the same texts
  // for the plan whose payment failed.
  renderPlanTexts = (subscription) => {
    const { nextSubscription } = this.props;
    const { isReactivating } = this.state;
    if (subscription?.subscriptionKey === 'STARTER_03_2023') {
      return (
        <div className='current-subscription-text'>
          {subscription?.subscriptionStatus === 'CANCELLED' ?
          <>
            <p>Sie nutzen aktuell das kostenlose hellohousing <span style={{fontWeight: 'bold'}}>Starter-Abonnement</span>. Dieses Abonnement wird nach dem <span style={{fontWeight: 'bold'}}>{subscription.cancellatinoDate}</span> nicht mehr unterstützt.</p>
            <p>Wählen Sie jetzt Ihr neues Abonnement, um hellohousing nach dem <span style={{fontWeight: 'bold'}}>{subscription.cancellatinoDate}</span> weiter nutzen zu können und auf Ihre Daten zugreifen zu können.</p>
          </>
          :
          <span>Sie nutzen derzeit das kostenlose hellohousing <span style={{fontWeight: 'bold'}}>Starter-Abonnement</span>.</span>}
        </div>
      );
    }
    if (subscription?.subscriptionStatus === 'CANCELLED') {
      // Undoing the cancellation keeps the current plan, so it needs no warning that a plan is
      // required. A cancelled plan with a follow-up plan is a downgrade the user scheduled, and
      // undoing it keeps the current plan too.
      const undoCancellation = (
        <div className='current-subscription-text' style={{height: 'auto'}}>
          Klicken Sie <span onClick={()=> !isReactivating && this.reactivateSubscriptinApi()} style={{textDecoration: 'underline', cursor: 'pointer'}}>hier</span>, um die Kündigung Ihres hellohousing {this.renderPlanName(subscription, true)} rückgängig zu machen.
        </div>
      );
      return nextSubscription ? (
        <>
          <div className='current-subscription-text' style={{height: 'auto'}}>
            Sie nutzen aktuell das hellohousing {this.renderPlanName(subscription)}.
          </div>
          <div className='current-subscription-text' style={{height: 'auto'}}>
            Ab dem <span style={{fontWeight: 'bold'}}>{dayjs(nextSubscription.startDate, 'DD.MM.YYYY').format('DD.MM.YYYY')}</span> nutzen Sie dann das {nextSubscription?.subscriptionKey === 'STARTER_03_2023' ? 'kostenlose ' : ''}hellohousing {this.renderPlanName(nextSubscription)}.
          </div>
          {undoCancellation}
        </>
      ) : (
        <>
          <div className='current-subscription-text' style={{height: 'auto'}}>
            Sie haben Ihr hellohousing {this.renderPlanName(subscription)} gekündigt. Zur Nutzung von hellohousing benötigen Sie ein Abonnement. Ab dem <span style={{fontWeight: 'bold'}}>{subscription?.cancellatinoDate}</span> verlieren Sie Zugriff auf alle Funktionen von hellohousing und auf alle Ihre Daten.
          </div>
          {undoCancellation}
        </>
      );
    }
    // The trial has its own texts above.
    return (
      <>
        {subscription?.subscriptionKey !== 'PROFESSIONAL_TESTING_12_2024' &&
        <div className='current-subscription-text' style={{height: 'auto'}}>
          Sie nutzen das {subscription?.subscriptionAmount > 0 ? '' : 'kostenlose '}hellohousing {this.renderPlanName(subscription)}.
        </div>}
        {subscription?.subscriptionAmount > 0 &&
        <div className='current-subscription-text'>
          Die Laufzeit Ihres Abonnements erneuert sich automatisch am <span style={{fontWeight: 'bold'}}>{subscription?.subscriptionRenewDate}</span> und <span style={{fontWeight: 'bold'}}>{formatNumber(subscription?.subscriptionAmount, true)}</span> werden mit Ihrer gewählten Zahlungsmethode eingezogen.
        </div>}
        {subscription?.subscriptionAmount > 0 &&
        <div className='current-subscription-text'>
          Nächster möglicher Kündigungstermin: {subscription?.possibleCancellationDate}. Klicken Sie <span onClick={()=> this.setState({openModal: true})} style={{textDecoration: 'underline', cursor: 'pointer'}}>hier</span>, um zu kündigen.
        </div>}
      </>
    );
  };

  render() {
    const { subsStatus, testPeriodCheck, cancellatinoDate, skeletonLoading, showNewSubscription, subscribtionSelected, paymentConfirmationModal, paymentMethodStatus, paymentMandate, subscriptionTypes, subscriptionName, openPaymentStatusModal, openPaymentRedirectModal, type, showLoader, cancelSubscriptionModal, openRestrictedMenuMessage, isCanceling} = this.state;
    const {currentSubscription, currentSubscriptionWithPaymentError, accountData, isMobile, hasTested, isTesting, nextSubscription, subscriptionData} = this.props;
    // While a payment has failed, Main.js sets currentSubscription to null and keeps the plan in
    // currentSubscriptionWithPaymentError; the cancellation dialog works on whichever is shown.
    const subscriptionShown = currentSubscriptionWithPaymentError || currentSubscription;
    // if periodEndDate before todaydate or today and endDate is same true means still active - case 1
    // if  periodEndDate before todaydate then false means over - case 2
    console.log('subscriptionData: ', subscriptionData);
    console.log('currentSubscription: ', currentSubscription);

    console.log('subscriptionTypes: ', subscriptionTypes);
    console.log('nextSubscription: ', nextSubscription);
    return (
      <>
        {/* {!showNewSubscription ?  */}
        <>
        {/* <Row style={{marginBottom: '18px', marginTop: '25px'}}>
              <Col xs={12}>
                <div className="payment-heading-main" style={{fontSize: '16px'}}>
                  Abonnements
                </div>
              </Col>
        </Row> */}
        <div id="response-user-account-subs-details" style={{ display: 'block', padding: 0 }}>
          {skeletonLoading ? 
          <div>
            <Skeleton visible={skeletonLoading} height={17.5} width={450} style={{marginBottom: '9px', marginTop: '6.5px'}}/>
            <Skeleton visible={skeletonLoading} height={84} width={352} style={{borderRadius: '4px', margin: '10px 24px 17px 0px'}} />
          </div>
          :
          <div>
            {currentSubscriptionWithPaymentError ? (
            <div className='current-subscription' style={{marginTop: '25px'}}>
              <span className='payment-heading-main' style={{marginBottom: '18px'}}>Aktuelles Abonnement</span>
              {this.renderCurrentPlanCard(currentSubscriptionWithPaymentError)}
              {this.renderPlanTexts(currentSubscriptionWithPaymentError)}
            </div>
            )
            :
            currentSubscription ? (
                <div className='current-subscription' style={{marginTop: '25px'}}>
                  <span className='payment-heading-main' style={{marginBottom: '18px'}}>Aktuelles Abonnement</span>
                  {this.renderCurrentPlanCard(currentSubscription)}
                  {console.log('currentSubscription?.testPeriodEnd: ', moment(currentSubscription?.testPeriodEnd).isAfter(moment()))}
                  {!isStarterTier(currentSubscription) && moment(currentSubscription?.testPeriodEnd).isAfter(moment()) &&
                  <div className='current-subscription-text' style={{height: 'auto'}}>
                    {currentSubscription?.subscriptionKey === 'PROFESSIONAL_TESTING_12_2024' ?
                    <Stack>
                      <span>Sie testen hellohousing kostenlos und unverbindlich bis zum <span style={{fontWeight: 'bold'}}>{moment(currentSubscription?.testPeriodEnd).format('DD.MM.YYYY')}</span>.</span>
                      {nextSubscription ?
                      <span>Ab dem <span style={{fontWeight: 'bold'}}>{nextSubscription.startDate}</span> nutzen Sie hellohousing im {this.renderPlanName(nextSubscription)}.</span>
                      :
                      <span>Wählen Sie noch heute Ihr Abonnement, um nach dem <span style={{fontWeight: 'bold'}}>{moment(currentSubscription?.testPeriodEnd).format('DD.MM.YYYY')}</span> Zugriff auf Ihre Daten zu behalten und hellohousing nahtlos weiter zu nutzen. Sie testen hellohousing in jedem Fall im vollen Umfang kostenlos bis zum Abschluss des Testzeitraums.</span>}

                      {nextSubscription &&
                      <div>
                          Klicken Sie <span onClick={()=> this.setState({openModal: true})} style={{textDecoration: 'underline', cursor: 'pointer'}}>hier</span>, um Ihr hellohousing {this.renderPlanName(nextSubscription)} zu kündigen.
                      </div>}
                    </Stack>
                    :
                    <span>Sie testen das hellohousing {this.renderPlanName(currentSubscription)} derzeit kostenlos bis zum <span style={{fontWeight: 'bold'}}>{moment(currentSubscription?.testPeriodEnd).format('DD.MM.YYYY')}</span>.</span>}
                  </div>
                  }
                  {this.renderPlanTexts(currentSubscription)}
                </div>
            ) : (
              <Stack style={{maxWidth: isMobile ? 'auto' : '450px'}}>
                {(!currentSubscription && hasTested) ?
                <div className='current-subscription'>
                  <br/>
                  <span className='payment-heading-main' style={{fontWeight: 'bold', whiteSpace: !isMobile && 'nowrap'}}>Bitte wählen Sie Ihr Abonnement</span>
                  <br/>
                  <br/>
                  <span className='current-subscription-text'>Um hellohousing zu nutzen, benötigen Sie ein Abonnement. Lernen Sie jetzt den Funktionsumfang von hellohousing Starter, Premium und Professional kennen und wählen Sie das für Ihre Bedürfnisse passende Abonnement aus. Monatliche Abonnements sind monatlich kündbar, jährliche Abonnements jährlich.</span>
                </div>
                :
                <div className='current-subscription'>
                  <br/>
                  <span className='payment-heading-main' style={{fontWeight: 'bold', whiteSpace: !isMobile && 'nowrap'}}>Testen Sie hellohousing 30 Tage kostenlos und unverbindlich</span>
                  <br/>
                  <br/>
                  <span className='current-subscription-text'>Testen Sie hellohousing 30 Tage kostenlos und unverbindlich im vollen Funktionsumfang. Der Testzeitraum endet automatisch. Im Anschluss wählen Sie ein passendes Abonnement aus. Ihre Daten bleiben erhalten.</span>
                </div>}
                {!(!currentSubscription && hasTested) &&
                <div>
                  <ColorButton
                  text={'Testzeitraum starten'}
                  className='purple-btn'
                  onClick={()=> this.setState({openRestrictedMenuMessage: true})}//this.createSubscriptionAssignment('97F226D5-A137-48E6-AA9A-605D4488DEC7')
                  />
                </div>}
                {/* <div className='upgrade-subscription' style={{marginTop: 0}}>
                  <div className='upgrade-subscription-text' style={{marginTop: 0}} onClick={()=> this.setState({showNewSubscription: true, subscribtionSelected: ''}, ()=> this.props.history.push('subscriptionsView', {subscriptionData, subscriptionTypes, subscribtionSelected, paymentMandate, nextSubscription}))}>
                    Mehr zu den Abonnements erfahren
                  </div>
                </div> */}
              </Stack>
            )}
            {((currentSubscription?.subscriptionKey === 'STARTER_03_2023' && currentSubscription?.subscriptionStatus === 'CANCELLED') || (!currentSubscription && hasTested) || (!nextSubscription && isTesting) || (currentSubscription?.subscriptionStatus === 'CANCELLED' && !nextSubscription)) && 
            <div style={{marginTop: '15px'}}>
              <ColorButton
              text={'Abonnements kennenlernen'}
              className={'purple-btn'}
              onClick={()=> this.setState({showNewSubscription: true, subscribtionSelected: ''}, ()=> this.props.history.push('subscriptionsView', {subscriptionData, subscriptionTypes, subscribtionSelected: '', paymentMandate, nextSubscription}))}
              />
            </div>}
            {<div className='upgrade-subscription'>
              <span className='payment-heading-main' style={{marginBottom: '18px'}}>Ihre Optionen</span>
              {subscriptionTypes//.filter((subscription)=> subscription?.subscriptionKey.includes('2024') || subscription?.subscriptionKey.includes(currentSubscription?.subscriptionKey))
              // The quick picks offer the annual plans, except the plan the account is on. A monthly
              // subscriber therefore also sees the annual version of their own tier.
              .filter((subscriptionType)=> getBillingPeriod(subscriptionType) === BILLING_PERIOD.ANNUAL)
              .sort((a,b)=> a.price - b.price)
              .filter((subscriptionType)=> subscriptionData.find((data)=> (currentSubscriptionWithPaymentError ? data.subscriptionAssignment === currentSubscriptionWithPaymentError?.subscriptionAssignment : data.subscriptionAssignment === currentSubscription?.subscriptionAssignment) && data.subscriptionKey === subscriptionType.subscriptionKey) === undefined)
              .filter((subscriptionType)=> nextSubscription ? subscriptionType.subscriptionKey !== nextSubscription.subscriptionKey : subscriptionType)
              .map((subscriptionType)=> {
                console.log('subscriptionType: ', subscriptionType);
              // Leaves out free plans such as the old free Starter plan (STARTER_03_2023). This used to
              // look for '2024' in Starter keys, which dropped the current Starter plan once its key
              // moved to the 10_2026 release.
              const paidPlan= subscriptionType.price > 0;
              const optionPrice = splitPriceForDisplay(getMonthlyEquivalentPrice(subscriptionType));
              // Every annual plan shows what it saves against paying monthly.
              const savingsPercent = getAnnualSavingsPercent(subscriptionType, subscriptionTypes);
              return (paidPlan &&
              <div className='upgrade-subscription-card' style={{height: 'auto', minHeight: '85px'}}>
                <div style={{width: '100%'}} onClick={()=> this.selectOption(subscriptionType)}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <span className='upgrade-subscription-card-value'>{optionPrice.euros}<span style={{fontSize: '13px'}}>{optionPrice.cents}</span>€</span>
                      <span className='upgrade-subscription-card-monat'> / {subscriptionType.billing === 'daily' ? 'täglich' : 'Monat'}</span>
                    </div>
                    <div style={{textAlign: 'right'}}>
                      {/* <img src={subscriptionType.subscriptionKey.split('_')[0] === 'PREMIUM' ?  PremiumBadgeIcon : subscriptionType.subscriptionKey.split('_')[0] === 'STARTER' ? StarterBadgeIcon : ProfessionalBadgeIcon} height={'24px'} /> */}
                      <SubscriptionBadgeIcon name={subscriptionType?.name} category={getSubscriptionTier(subscriptionType)} />
                      {(accountData.isPremiumPlanTested === false || accountData.isProfessionalPlanTested === false ) &&
                      <div className='upgrade-subscription-card-monat' style={{fontSize: '10px', whiteSpace: 'nowrap', fontWeight: 400, marginLeft: 0, marginTop: '5px'}}>
                        {subscriptionType.price > 0 && (currentSubscription?.subscriptionTypeId === '97f226d5-a137-48e6-aa9a-605d4488dec7' ? '' : hasTested ? 'Jetzt freischalten' : 'Kostenlos testen')}
                      </div>}
                    </div>
                  </div>
                  <span className='upgrade-subscription-card-monat' style={{marginLeft: 0}}>
                    {getBillingPeriodLabel(subscriptionType)}
                    {savingsPercent ? <> - <b>Sie sparen {formatSavingsPercent(savingsPercent)}</b></> : null}
                  </span>
                </div>
                {/* <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                  <div className='upgrade-subscription-card-monat' style={{fontSize: '10px', whiteSpace: 'nowrap', marginLeft: 0, marginTop: '-10px'}}>
                    {subscriptionType.subscriptionKey.split('_')[0] === 'PREMIUM' ? accountData.isPremiumPlanTested === false && 'Jetzt freischalten' : subscriptionType.subscriptionKey.split('_')[0] === 'PROFESSIONAL' && accountData.isProfessionalPlanTested === false && 'Jetzt freischalten'}
                  </div> 
                </div> */}
              </div>);
              })}
              <div className='upgrade-subscription-text' onClick={()=> this.setState({showNewSubscription: true, subscribtionSelected: ''}, ()=> this.props.history.push('subscriptionsView', {subscriptionData, subscriptionTypes, subscribtionSelected: '', paymentMandate, nextSubscription}))}>
                Mehr zu den Abonnements erfahren
              </div>
            </div>}
          </div>}
        </div>
        {this.state.openModal &&
        <DeleteModal
          open={this.state.openModal}
          className="delete-rent-modal"
          toggle={()=>this.setState({openModal: !this.state.openModal})}
          // record={this.state.tenant}
          handleDelete={() => (subscriptionShown?.subscriptionStatus === 'CANCELLED' || subscriptionShown?.subscriptionKey === 'PROFESSIONAL_TESTING_12_2024') ? !isCanceling && this.cancelSubscriptionAPi(nextSubscription.subscriptionAssignment, nextSubscription?.subscriptionKey) : this.reactivateCancelSub()}
          // showInfo={[this.state.currentUnit.name, `${this.state.currentUnit.size} m²`]}
          textShowModal={'Abonnement kündigen'}
          showLoader={isCanceling}
          showtext={false}
          showDeleteText={false}
          typeText={
            //(currentSubscription?.subscriptionStatus !== 'CANCELLED' ?
            <span><p>Sie benötigen ein gültiges Abonnement, um hellohousing nutzen zu können.</p><p style={{fontWeight: 'bold'}}>Wenn Sie Ihr Abonnement jetzt kündigen, dann verlieren Sie ab dem {subscriptionShown?.subscriptionKey === 'PROFESSIONAL_TESTING_12_2024' ? dayjs(subscriptionShown?.testPeriodEnd).add(1, 'day').format('DD.MM.YYYY') : subscriptionShown?.nextPaymentDue} Zugriff auf alle Funktionen von hellohousing sowie auf Ihre Daten.</p><p>Sind Sie sicher, dass Sie Ihr Abonnement kündigen wollen?</p></span> //: nextSubscription.nextPaymentDue
            // currentSubscription?.subscriptionKey.split('_')[0] === 'PREMIUM' : nextSubscription.subscriptionName === 'Premium') ?
            // <Stack gap={10}>
            //   <Group>
            //     <span>Mit der Kündigung von hellohousing Premium <span style={{fontWeight: 'bold'}}>verlieren Sie ab dem {currentSubscription?.subscriptionStatus === 'CANCELLED' ? nextSubscription.nextPaymentDue : renewDate} Zugriff auf diese Premium Funktionen und Daten</span></span>
            //   </Group>
            //   <Group>
            //     <ul style={{marginBottom: 0, paddingLeft: 14}}>
            //       <li>Nur noch 1 Immobilie mit maximal 9 Mieteinheiten verwalten</li>
            //       <li>Heizkostenabrechnungen durchführen</li>
            //       <li>Gewerbliche Mieter verwalten mit MwSt.-Ausweis</li>
            //       <li>Eigenes Logo einbinden</li>
            //       <li>Automatisierte Belegerkennung mit KI-Unterstützung</li>
            //       <li>Beschränkung auf 100 MB Speicherplatz für Dokumente (statt 1 GB)</li>
            //       <li>Expertensupport via Chat, Email und Telefon</li>
            //     </ul>
            //   </Group>
            //   <Group>
            //     <span>Sind Sie sicher, dass Sie Ihr Premium Abonnement kündigen wollen?</span>
            //   </Group>
            // </Stack>
            // :
            // (currentSubscription?.subscriptionStatus !== 'CANCELLED' ?
            // currentSubscription?.subscriptionKey.split('_')[0] === 'PROFESSIONAL' : nextSubscription.subscriptionName === 'Professional') ?
            // <Stack gap={10}>
            //   <Group>
            //     <span>Mit der Kündigung von hellohousing Professional <span style={{fontWeight: 'bold'}}>verlieren Sie ab dem {renewDate} Zugriff auf diese Professional Funktionen und Daten</span></span>
            //   </Group>
            //   <Group>
            //     <ul style={{marginBottom: 0, paddingLeft: 14}}>
            //       <li>Nur noch 1 Immobilie mit maximal 9 Mieteinheiten verwalten</li>
            //       <li>Heizkostenabrechnungen durchführen</li>
            //       <li>Gewerbliche Mieter verwalten mit MwSt.-Ausweis</li>
            //       <li>Eigenes Logo einbinden</li>
            //       <li>Automatisierte Belegerkennung mit KI-Unterstützung</li>
            //       <li>Beschränkung auf 100 MB Speicherplatz für Dokumente (statt 2 GB)</li>
            //       <li>Expertensupport via Chat, Email und Telefon</li>
            //       <li>Funkzählerdaten einbinden und verarbeiten</li>
            //       <li>Kein Zugriff auf das Mieterportal mehr möglich</li>
            //     </ul>
            //   </Group>
            //   <Group>
            //     <span>Sind Sie sicher, dass Sie Ihr Professional Abonnement kündigen wollen?</span>
            //   </Group>
            // </Stack>
            // :
            // `Sie sind dabei Ihr hellohousing ${subscriptionName} Abonnement zu kündigen. Ab dem ${renewDate} nutzen Sie dann das Starter Paket. Sie können dann nicht mehr auf die Zusatzfunktionen des ${subscriptionName} Paketes zugreifen. Sind Sie sicher, dass Sie fortfahren möchten?`)
          }
          modalId="unit-delete-modal-footer"
          rightButtonText={'Abonnement kündigen'}
          leftButtonText={'Abbrechen'}
          leftButtonClassName={'purple-btn'}
        />}

        <button id='show-loader' style={{display: 'none'}} onClick={()=> this.ShowLoader()}/>
        
        {/* // :
        // <>
        // <NewSubscription
        // subscriptionData={subscriptionData}
        // subscriptionTypes={subscriptionTypes}
        // subscribtionSelected={subscribtionSelected}
        // closeNewSubscription={(selectedSubscription=null)=> this.setState({showNewSubscription: false, subscribtionSelected: selectedSubscription, paymentConfirmationModal: selectedSubscription && accountData.accountPaymentStatus === 'AUTHORIZED' && true, openPaymentStatusModal: selectedSubscription && accountData.accountPaymentStatus !== 'AUTHORIZED' && true})}
        // paymentMandate={paymentMandate}
        // /> */}
        </>
        {paymentConfirmationModal &&
        <PaymentConfirmationModal
        open={paymentConfirmationModal}
        subscribtionSelected={subscribtionSelected}
        subscriptionTypes={subscriptionTypes}
        toggle={()=> this.setState({paymentConfirmationModal: false})}
        confirmPayment={()=> this.createSubscriptionAssignment()}
        showLoader={showLoader}
        />}
        {openPaymentStatusModal &&
        <PaymentTemplateSuccessModal
        open={openPaymentStatusModal}
        toggle={()=>this.setState({openPaymentStatusModal: false})}
        onNext={()=> this.setState({paymentConfirmationModal: true, openPaymentStatusModal: false})}
        type={'authorize'}
        history={this.props.history}
        authorize={()=>
          //this.authorizePayment()
          this.setState({openPaymentRedirectModal: true, openPaymentStatusModal: false})
        }
        getPaymentDetails={()=> this.getPaymentDetails()}
        />}
        {openPaymentRedirectModal &&
        <PaymentTemplateModal
        open={openPaymentRedirectModal}
        toggle={()=>this.setState({openPaymentRedirectModal: false})}
        type={type}
        route={'/profile/yourSubscription'}
        subscribtionSelected={subscribtionSelected}
        subscribtionSelectedName={this.state.subscribtionSelectedName}
        openPaymentStatusModal={()=> this.setState({openPaymentStatusModal: true})}
        />}

      {openRestrictedMenuMessage &&
      <RestrictedMenuMessageModal
      open={openRestrictedMenuMessage}
      toggle={()=> this.setState({openRestrictedMenuMessage: false})}
      history={this.props.history}
      />}
      </>
    );
  }
}

// export default YourSubscription;

const mapStateToProps = (state) => {
  return {
    profile: state.generalReducer.profile,
    AccountApi: state.generalReducer.account_api_id,
    currentSubscription: state.generalReducer.currentSubscription,
    currentSubscriptionWithPaymentError: state.generalReducer.currentSubscriptionWithPaymentError,
    accountData: state.generalReducer.accountData,
    selectedSubscriptionForPaymentConfirmation: state.generalReducer.selectedSubscriptionForPaymentConfirmation,
    hasTested: state.generalReducer.hasTested,
    isTesting: state.generalReducer.isTesting,
    nextSubscription: state.generalReducer.nextSubscription,
    // Main.js loads the subscription assignments for the whole app (getsubscriptionsAssignments
    // here only clicks its hidden button), so this page reads the list from the store.
    subscriptionData: state.generalReducer.subscription,
  };
};

const actions = {
  setSubscriptionData,
  setCurrentSubscriptionData,
  setCurrentSubscriptionDataWithPaymentError,
  setSelectedSubscriptionForPaymentConfirmation,
  setAccountData,
  setCompanyLogo,
  setNextSubscriptionData,
  setTestSubscriptionComplete,
  setIsTesting,
  setIsLogoHidden
};

export default connect(mapStateToProps, actions)(YourSubscription);
